import { http } from './http'

// const API_URL = import.meta.env.VITE_API_URL

// Define base URLs for different modules. Add or update moduleIds and their corresponding base URLs as needed.
const moduleBaseUrls: Record<number, string> = {
    1: 'PlatformCoreServices/Authorize/Menu', // UserManagement module
    9: 'PlatformCoreServices/Accounts/Menu', // Accounts module
    12: 'PlatformCoreServices/MOPHR/Menu', // HR module
    14: 'PlatformCoreServices/MOPQueueManagement/Menu', // Queue module
    10: 'PlatformCoreServices/TaskMgmt/Menu', // Queue module
    15: 'PlatformCoreServices/Communication/Menu' //Communication module
    // Add entries for other modules, e.g.:
    // 2: 'PlatformCoreServices/AssetManagement/Menu', // Asset Management
    // 3: 'PlatformCoreServices/TaskManagement/Menu', // Task Management
    // Future modules can be added here
}

const getBaseUrl = (moduleId: number): string => {
    // return moduleBaseUrls[moduleId] || 'PlatformCoreServices/Accounts/Menu' // Default to Accounts if moduleId not found
return moduleBaseUrls[moduleId] || 'PlatformCoreServices/Authorize/Menu'
}

// const BASE_URL = 'PlatformCoreServices/Accounts/Menu'

export interface MenuItem {
    id: number;
    name: string;
    icon?: string;
    route?: string;
    parentId?: number;
    isOpen?: boolean;
    menuId?: number;
    menuName?: string;
    subMenuId?: number;
    creationPath: string;
    FormType: number;
    subMenuName?: string;
    path?: string;
    fixedHref?: string;
    entityId?: number;
    iscommon?: number;
    Type?: number;
    MenuId?: number;
    MenuName?: string;
    SubMenuId?: number;
    SubMenuName?: string;
    EntityId?: number;
    FixedHref?: string;
    Path?: string;
    MenuStatus?: boolean;
    SubMenuStatus?: boolean;
    IsActive?: boolean;
    MenuDisplayOrder?: number;
    SubMenuDisplayOrder?: number;
    Content?: string | null;
    Image?: string;
    OperationName?: string;
    StoreRights?: Record<string, unknown>;
    MenuPath?: string | null;
}

export interface MenuResponse {
    menus: MenuItem[];
    subMenus: MenuItem[];
}

export class MenuService {
    static async getMenuSubMenuList(type: number, roleId: number, organizationId: number, moduleId: number): Promise<MenuItem[]> {
        try {
            const baseUrl = getBaseUrl(moduleId)
            console.log('Making API request to:', `${baseUrl}/GetMenuSubMenuList`)
            console.log('Request params:', { type, roleId, organizationId })

            const response = await http.get<{ result: MenuItem[] }>(`${baseUrl}/GetMenuSubMenuList`, {
                params: {
                    Type: type,
                    RoleId: roleId,
                    OrganizationId: organizationId,
                    ModuleId: moduleId
                }
            })

            // Log the raw response for debugging
            console.log('Raw API response:', JSON.stringify(response, null, 2))

            // Extract the menu data from response.data.result
            const menuData = response?.result;
            console.log('Extracted menu data:', JSON.stringify(menuData, null, 2))

            // Ensure we have valid menu data
            if (!Array.isArray(menuData)) {
                console.warn('Menu data is not an array:', menuData)
                return [];
            }

            // Filter out any null or undefined items
            const validMenuData = menuData.filter(item => {
                if (!item) {
                    console.warn('Filtered out null/undefined menu item')
                    return false;
                }

                // Ensure required properties exist
                if (!item.MenuId || !item.MenuName) {
                    console.warn('Filtered out invalid menu item:', item)
                    return false;
                }

                return true;
            });

            console.log('Final processed menu data:', JSON.stringify(validMenuData, null, 2))
            return validMenuData;

        } catch (error: unknown) {
            const err = error as { message?: string; response?: { data?: { ErrorInfo?: { ErrorMessage?: string }; message?: string }; status?: number }; config?: { url?: string }; stack?: string }
            console.error('Menu API Error:', {
                message: err?.message,
                response: err?.response?.data,
                status: err?.response?.status,
                url: err?.config?.url,
                stack: err?.stack
            })
            throw this.handleError(error)
        }
    }

    private static handleError(error: unknown): Error {
        const err = error as { message?: string; response?: { data?: { ErrorInfo?: { ErrorMessage?: string }; message?: string } } }
        const errorMessage =
            err?.response?.data?.ErrorInfo?.ErrorMessage ||
            err?.response?.data?.message ||
            err?.message ||
            'Failed to fetch menu data'

        return new Error(errorMessage)
    }
}
// Export a singleton instance
export const menuService = MenuService
